import { lazy, Suspense } from 'react';
import { RouteObject } from 'react-router-dom';
import { ErrorBoundary } from "@/shared/components/ErrorBoundary";
import { Spin } from 'antd';

// Lazy load views
const LoanApplicationView = lazy(() => import('./views/LoanApplicationView'));
const MyLoanApplicationsView = lazy(() => import('./views/MyLoanApplicationsView'));
const LoanApplicationDetailsView = lazy(() => import('./views/LoanApplicationDetailsView'));
const LoanRequestsView = lazy(() => import('./views/LoanRequestsView'));
const CompletedLoanRequestsView = lazy(() => import('./views/CompletedLoanRequestsView'));
const LoanActionFlowApprovalView = lazy(() => import('./views/LoanActionFlowApprovalView'));

// Loading fallback component
const LoadingFallback = () => (
  <div className="flex justify-center items-center h-full p-8">
    <Spin size="large" tip="Loading..." />
  </div>
);

export const loanRoutes: RouteObject[] = [
  {
    path: '/loans/application',
    element: (
      <Suspense fallback={<LoadingFallback />}>
        <LoanApplicationView />
      </Suspense>
    ),
    errorElement: <ErrorBoundary />,
  },
  {
    path: '/loans/my-applications',
    element: (
      <Suspense fallback={<LoadingFallback />}>
        <MyLoanApplicationsView />
      </Suspense>
    ),
    errorElement: <ErrorBoundary />,
  },
  {
    path: '/loans/my-applications/:scopeId',
    element: (
      <Suspense fallback={<LoadingFallback />}>
        <LoanApplicationDetailsView />
      </Suspense>
    ),
    errorElement: <ErrorBoundary />,
  },
  {
    path: '/requests/loans/pending',
    element: (
      <Suspense fallback={<LoadingFallback />}>
        <LoanRequestsView />
      </Suspense>
    ),
    errorElement: <ErrorBoundary />,
  },
  {
    path: '/requests/loans/completed',
    element: (
      <Suspense fallback={<LoadingFallback />}>
        <CompletedLoanRequestsView />
      </Suspense>
    ),
    errorElement: <ErrorBoundary />,
  },
  {
    path: '/loans/completed-requests/:scopeId',
    element: (
      <Suspense fallback={<LoadingFallback />}>
        <LoanApplicationDetailsView />
      </Suspense>
    ),
    errorElement: <ErrorBoundary />,
  },
  {
    // Loan-specific approval view — injects loan custom components into ActionFlowApprovalView
    path: '/requests/loans/approval/:scopeId',
    element: (
      <Suspense fallback={<LoadingFallback />}>
        <LoanActionFlowApprovalView />
      </Suspense>
    ),
    errorElement: <ErrorBoundary />,
  },
];
